export function scrollOffset(element, offset = 0, alignment = 'top') {
  const body = document.body
  const html = document.documentElement
  const elemRect = element.getBoundingClientRect()
  const clientHeight = html.clientHeight
  const documentHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight,
  )
  let scrollPosition

  if (alignment === 'bottom') {
    scrollPosition = elemRect.bottom - clientHeight
  } else if (alignment === 'middle') {
    scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2
  } else {
    // top and default
    scrollPosition = elemRect.top
  }

  const maxScrollPosition = documentHeight - clientHeight
  return Math.min(scrollPosition + offset + window.pageYOffset, maxScrollPosition)
}

/**
 * Return true if child is contained in parent
 * @param parent {HTMLElement}
 * @param child {HTMLElement}
 * @returns {boolean}
 */
export function isDescendant(parent, child) {
  if (!child || !child.parentNode) return false
  let node = child.parentNode

  while (node != null) {
    if (node === parent) {
      return true
    }

    node = node.parentNode
  }

  return false
}
let matchesFn

/**
 * Find the closest element that matches the selector
 * @param el {HTMLElement}
 * @param selector {string}
 * @returns {HTMLElement}
 */
export function closest(el, selector) {
  if (!matchesFn) {
    // find vendor prefix
    ;[
      'matches',
      'webkitMatchesSelector',
      'mozMatchesSelector',
      'msMatchesSelector',
      'oMatchesSelector',
    ].some((fn) => {
      if (typeof document.body[fn] === 'function') {
        matchesFn = fn
        return true
      }

      return false
    })
  }

  // traverse parents
  let parent
  let element = el

  while (element !== null) {
    parent = element.parentElement

    if (parent !== null && parent[matchesFn](selector)) {
      return parent
    }

    element = parent
  }

  return null
}

/**
 * Get the previous sibling DOM node to an element
 * @param node {HTMLElement}
 * @returns {HTMLElement}
 */
export function previousSibling(node) {
  if (!node) return null
  let element = node

  do {
    element = element.previousSibling
    if (!isIgnorable(element)) return element
  } while (element)

  return null
}

/**
 * Get the next sibling DOM node to an element
 * @param node {HTMLElement}
 * @returns {HTMLElement}
 */
export function nextSibling(node) {
  if (!node) return null
  let element = node

  do {
    element = element.nextSibling
    if (element && !isIgnorable(element)) return element
  } while (element)

  return null
}

/**
 * Ignore commment and text nodes.
 * @param node
 * @returns {*}
 */
function isIgnorable(node) {
  if (!node) return null
  return node.nodeType === 8 || (node.nodeType === 3 && isAllWs(node))
}

/**
 * Ignore all whitespace nodes
 * @param node
 * @returns {*}
 */
function isAllWs(node) {
  if (!node) return null
  // Use ECMA-262 Edition 3 String and RegExp features
  return !/[^\t\n\r ]/.test(node.textContent)
}

export function getNodePath(node) {
  if (!node) return null
  let currentNode = node
  let path

  while (currentNode.parentNode) {
    const tag = currentNode.tagName.toLowerCase()
    const classes = currentNode.getAttribute('class')
    const className = classes ? `.${classes.trim().split(' ').join('.')}` : ''

    if (path) {
      path = `${tag}${className} > ${path}`
    } else {
      path = `${tag}${className}`
    }

    // Move up in the tree
    currentNode = currentNode.parentNode
  }

  return path
}
export function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}
export function truncateString(string, length) {
  if (string.length > length) {
    if (typeof string === 'string' && typeof length === 'number') {
      return string.substring(0, length) + '\u2026'
    } else {
      throw new Error('Function truncateString take args @string, @number')
    }
  } else return string
}
export default {
  closest,
  isDescendant,
  previousSibling,
  nextSibling,
  scrollOffset,
  getNodePath,
  insertAfter,
  truncateString,
}